<template>
<div id="app">
	<header>
		<router-link :to="{ name: 'Dashboard' }">
			<img src="./assets/img/tmf-logo.svg" alt="Track My FCEV">
		</router-link>
		<i class="loading" v-if="app.isLoading"><i class="loading--internal"></i></i>
		<div v-if="getToken()">
			<el-dropdown trigger="click">
				<span class="el-dropdown-link">
					{{ app.user.first_name }} {{ app.user.last_name }} <i class="el-icon-caret-bottom el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<li class="el-dropdown-menu__item" @click="profile">
						Profile
					</li>
					<li class="el-dropdown-menu__item" @click="logout">
						Logout
					</li>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div v-else>
			<router-link :to="{ name: 'Login' }">Login</router-link>
			<router-link :to="{ name: 'Register' }">Register</router-link>
		</div>
	</header>
	<nav v-if="getToken()">
		<router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
		<router-link :to="{ name: 'Analysis' }">Analysis</router-link>
		<router-link :to="{ name: 'History' }">Fuelling History</router-link>
	</nav>
	<main>
		<el-row v-if="app.messages.length" type="flex" justify="center">
			<el-col :xs="24" :sm="12" :md="10" :lg="8">
				<el-alert v-for="(message,index) in app.messages" :title="message" type="info" show-icon :key="index">
				</el-alert>
			</el-col>
		</el-row>
		<transition name="slide" mode="out-in">
			<router-view></router-view>
		</transition>
	</main>
	<footer>
		<el-row>
			<el-col :xs="24" :sm="12">
				<ul>
					<li>
						<a href="http://www.cenex.co.uk/" target="_blank" rel="noopener">
							About Cenex
						</a>
					</li>
					<li>
						<router-link :to="{ name: 'Terms' }">Terms &amp; Conditions</router-link>
					</li>
				</ul>
			</el-col>
			<el-col :xs="24" :sm="12">
				<p>
					&copy; 2017 Cenex
				</p>
			</el-col>
		</el-row>
	</footer>
</div>
</template>

<script>
import router from "@/router";
import { getUser, getToken, endSession } from "@/utils/auth";
import store from "@/utils/store";
export default {
	name: "app",
	data: function() {
		return {
			app: store
		};
	},
	methods: {
		getToken,
		getUser,
		profile() {
			router.push({
				name: "Profile"
			});
		},
		logout() {
			endSession();
		}
	}
};
</script>

<style lang="stylus">
	@import "./assets/stylus/main"
	.loading
		margin-left: auto;
		margin-right: auto;
	.loading
	.loading--internal
		border 2px solid transparent
		border-left-color white
		border-right-color white
		box-sizing border-box
		display inline-block
		width 20px
		height 20px
		border-radius 10px
		animation rotateloader 2s infinite linear

	.loading--internal
		display: block;
		margin: 3px;
		width 10px
		height 10px
		border-radius 10px
		animation rotateloader 1s infinite linear reverse

	.el-dropdown
		color white
		margin-right 1em

	@keyframes rotateloader
		from
			transform rotate(0deg)
			border-right-color white
			border-left-color white
		to
			transform rotate(360deg)
			border-right-color green
			border-left-color red

</style>



// WEBPACK FOOTER //
// App.vue?7a651c25